import React, { useEffect, useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
function CreditcardServiceMain() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const checkEKOonboardStatus = () => {
    if (profiledetail.eko_onboard_status == "0") {
      return true;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("300.11"));
  }, []);
  return (
    <div className="m-4">
      {" "}
      {(memberServices.includes("111") || memberServices.includes("121")) && (
        <div className="grid grid-cols-1  md:grid-cols-3  place-items-start gap-3">
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              Credit Card
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("111")
                      ? "/eko/credit-card"
                      : memberServices.includes("121")
                        ? "/pay_fusion/credit-card"
                        : "/not-available",
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">
                  Credit Card
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default CreditcardServiceMain;
